import { NavLink, useLocation } from "react-router-dom";
import { Home, Search, Trophy, User, Share2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { dashPathFor } from "./GoogleAuth";

export default function MobileNav() {
  const { user } = useAuth();
  const location = useLocation();
  const profilePath = dashPathFor(user);
  const items = [
    { to: "/", label: "Home", Icon: Home, id: "home", end: true },
    { to: "/institutes", label: "Search", Icon: Search, id: "search" },
    { to: "/rankings", label: "Leaderboard", Icon: Trophy, id: "leaderboard" },
    { to: "/referrals", label: "Referral", Icon: Share2, id: "referral" },
    { to: profilePath, label: "Profile", Icon: User, id: "profile" },
  ];
  return (
    <nav data-testid="mobile-bottom-nav" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t-2 border-[#171B33]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="grid grid-cols-4">
        {items.map(({ to, label, Icon, id, end }) => (
          <NavLink key={id} to={to} end={end} data-testid={`mobile-nav-${id}`} data-active={location.pathname === to || (id === "search" && ["/teachers", "/home-tuition", "/institutes"].some((p) => location.pathname.startsWith(p)))}
            className={({ isActive }) => `flex flex-col items-center gap-1 py-2.5 text-[11px] font-bold transition-colors ${isActive ? "text-[#171B33]" : "text-slate-400"}`}>
            {({ isActive }) => (
              <>
                <span className={`w-9 h-7 rounded-lg flex items-center justify-center transition-colors ${isActive ? "bg-[#A3E635] border-2 border-[#171B33]" : ""}`}>
                  <Icon className="w-4 h-4" />
                </span>
                {label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
